export enum MyLocationEnum {
  Lobby = "/lobby",
  Live = "/live",
  Dagskra = "/agenda",
  Speaker = "/speaker",
  _404LostAndAlone = "/404",
  Records = "/records",
  skraning = "/skraning"
}
